import { useOnlineStatus } from '../../hooks/useOnlineStatus'
import { Wifi, WifiOff } from 'lucide-react'

export function OnlineIndicator() {
  const { isOnline, wasOffline } = useOnlineStatus()

  if (isOnline && !wasOffline) return null

  return (
    <div 
      className={`fixed top-0 left-0 right-0 z-50 py-2 px-4 text-center text-sm font-medium transition-all ${
        isOnline 
          ? 'bg-green-500 text-white' 
          : 'bg-red-500 text-white'
      }`}
    >
      <div className="flex items-center justify-center space-x-2">
        {isOnline ? (
          <>
            <Wifi className="h-4 w-4" />
            <span>Connessione ripristinata</span>
          </>
        ) : (
          <>
            <WifiOff className="h-4 w-4" />
            <span>Sei offline - Le modifiche verranno salvate al ripristino della connessione</span>
          </>
        )}
      </div>
    </div>
  )
}
